import styled from 'styled-components'

export default styled.span`
  position: relative;
  ::after {
    content: '';
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 3px;
    border-width: 0 0 1px;
    border-style: solid;
    transition: opacity 0.2s;
  }
`



// WEBPACK FOOTER //
// ./components/atoms/underlined.js